<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-para"><span class="bolditalic">Disclaimer:</span> This book should not be viewed as medical or psychiatric intervention; however, for the vast majority of readers, if you are receptive, this book will give you the opportunity to learn, grow and discover what true happiness and inner peace feel like.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm01.vue?463b69e5